<div class="cp-grid-container custom-grid" [hidden]="isHidden">
    <se-floating-label
        [class.invisible]="!control.isWithLabel"
        [for]="control.id"
        [state]="isDisabled ? 'disabled' : 'active'"
        [tooltip]="control.name"
        [materialStyle]="true"
    >
        {{ control.name }}
    </se-floating-label>

    <form class="cp-grid-form" [formGroup]="formGroup" #gridContainer>
        <ag-grid-angular
            style="width: 100%; height: 100%"
            (cellValueChanged)="onNotifyModelChange($event)"
            (columnResized)="onColumnResized($event)"
            (gridReady)="onGridReady($event)"
            (gridSizeChanged)="onGridSizeChanged($event)"
            (firstDataRendered)="onFirstDataRendered($event)"
            (rowDataUpdated)="onRowDataUpdated($event)"
            (rowEditingStopped)="onRowEditingStopped($event)"
            (keydown.alt.enter)="_onAltEnter($event)"
            [colResizeDefault]="control.colResizeDefault"
            [columnDefs]="control.columnDefs"
            [components]="control.gridComponents"
            [context]="getContext()"
            [enableBrowserTooltips]="control.enableBrowserTooltips"
            [getRowId]="getRowId"
            [modules]="agGridModuls"
            [overlayNoRowsTemplate]="noRowsTemplate"
            [pagination]="control.pagination"
            [paginationAutoPageSize]="control.paginationAutoPageSize"
            [rowHeight]="rowHeight"
            [rowSelection]="rowSelection"
            [singleClickEdit]="control.singleClickEdit"
            [style.height.px]="control.getHeight() - 2"
            [stopEditingWhenCellsLoseFocus]="control.stopEditingWhenCellsLoseFocus"
            [suppressNoRowsOverlay]="control.suppressNoRowsOverlay"
            [suppressRowHoverHighlight]="isDisabled"
            [suppressScrollOnNewData]="control.suppressScrollOnNewData"
            [theme]="agGridTheme"
            [tooltipShowDelay]="control.tooltipShowDelay"
        >
        </ag-grid-angular>
        <div class="se-buttons-grid">
            <div style="flex: 1">
                <cp-additional-content
                    *ngFor="let additionalContent of control.additionalContent"
                    [control]="additionalContent"
                    [cardId]="cardId"
                    [disabled]="isDisabled"
                    (edited)="onChangeFromAdContent()"
                >
                </cp-additional-content>
            </div>
            <div *ngIf="_enableButtonRemoveAllRows">
                <button
                    mat-icon-button
                    (click)="removeAllRows()"
                    [disabled]="isDisabled"
                    title="{{ 'RemoveAll' | translate }}"
                >
                    <mat-icon>delete_sweep</mat-icon>
                </button>
            </div>
        </div>
    </form>
</div>
